<template>
    <div class="relative rounded-2xl overflow-hidden">
        <Loading v-if="loading" class="min-h-[50vh]" />
        <template v-for="item in cartItems" :key="item.id">
            <!-- Product booking -->
            <template v-if="item.attributes?.modelType === 'product'">
                <BookingSummary :item />
            </template>

            <template v-else>
                <div class="flex justify-between gap-4 px-4 text-[15px] mt-1">
                    <div>
                        {{ item.name }}
                        <template v-if="item.attributes?.inputType === 'quantity'">x {{ item.quantity }}</template>
                    </div>
                    <div>
                        {{ $n(item.displaySubTotal, 'currency') }}
                        <template v-if="item.attributes?.payAtLocation">*</template>
                    </div>
                </div>

                <div v-if="getRequirementRows(item).length" class="px-4 ml-2 mt-1 space-y-1">
                    <div v-for="(row, rowIndex) in getRequirementRows(item)" :key="`req-${item.id}-${rowIndex}`" class="text-xs text-gray-500">
                        {{ row }}
                    </div>
                </div>
            </template>
            <template v-if="item.attributes?.breakdown">
                <div class="px-4 space-y-1 pt-4">
                    <div class="text-[15px]">{{ $t('Accommodation') }}</div>
                    <div class="ml-2 space-y-1">
                        <template v-for="(row, index) in item.attributes.breakdown" :key="index">
                            <div class="flex justify-between gap-4 text-sm text-gray-600">
                                <span>{{ row.label }}</span>
                                <div>
                                    {{ $n(row.total, 'currency') }}
                                    <template v-if="row.payAtLocation">*</template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </template>

        <template v-for="item in cartConditions" :key="item.id">
            <div class="flex justify-between gap-4 px-4 text-[15px] mt-1">
                <div>{{ item.attributes?.label || item.name }}</div>
                <div>{{ $n(item.total, 'currency') }}</div>
            </div>
        </template>

        <div class="bg-pink-50 px-4 py-3 rounded-b-2xl mt-4">
            <div class="flex justify-between gap-4 text-lg font-semibold space-y-1 text-pink-600">
                <div>{{ $t('Total') }}</div>
                <div>{{ $n(cartTotal, 'currency') }}</div>
            </div>
            <div class="text-xs text-pink-500">{{ $t('Items marked with * are paid at the property.') }}</div>
        </div>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useCartStore } from '@/stores/cart.js'
import BookingSummary from './BookingSummary.vue'
import { getRequirementRowsFromPayload } from '@/utils/cartRequirements'
const { cartItems, cartConditions, cartTotal, loading } = storeToRefs(useCartStore())

const getRequirementRows = (item) => {
    return getRequirementRowsFromPayload(item?.attributes?.requirementsPayload)
}
</script>
